/**
 * 多选 / 联合包围盒：单一边框 + 四角缩放手柄（无旋转、圆角柄）。
 */
import type { ResizeHandle } from '@/components/canvas/transform';
import { createPagePseudoElement } from './pageSelection';
import { SelectionBoxLayer } from './SelectionBoxLayer';
import { HandleLayer } from './HandleLayer';

export interface UnionSelectionChromeProps {
  rect: { x: number; y: number; width: number; height: number };
  zoom: number;
  dragOffset?: { dx: number; dy: number };
  onStartUnionResize: (handle: ResizeHandle, e: React.MouseEvent) => void;
  /** 为 true 时不绘制联合框（仅手柄，用于已有逐元素选框时） */
  hideBorder?: boolean;
}

export function UnionSelectionChrome({
  rect,
  zoom,
  dragOffset = { dx: 0, dy: 0 },
  onStartUnionResize,
  hideBorder = false,
}: UnionSelectionChromeProps) {
  const { dx, dy } = dragOffset;
  const absX = rect.x + dx;
  const absY = rect.y + dy;
  const pseudo = createPagePseudoElement(rect.width, rect.height);
  pseudo.layout = { ...pseudo.layout, x: absX, y: absY };
  const handleRect = { x: absX, y: absY, width: rect.width, height: rect.height };
  const noop = () => {};

  return (
    <div className="absolute inset-0 pointer-events-none z-[4]" aria-hidden>
      {!hideBorder && (
        <SelectionBoxLayer elements={[pseudo]} dragOffset={{ dx: 0, dy: 0 }} zoom={zoom} />
      )}
      <HandleLayer
        element={pseudo}
        rect={handleRect}
        zoom={zoom}
        isLine={false}
        lineEndX={0}
        lineEndY={0}
        currentRadius={0}
        showRotate={false}
        showRadiusHandles={false}
        resizeHandles={['nw', 'ne', 'se', 'sw']}
        onStartResize={onStartUnionResize}
        onStartLineHandle={noop}
        onStartRotate={noop}
        onStartRadiusDrag={noop}
      />
    </div>
  );
}
